import { motion } from 'framer-motion';
import SupplierApplicationForm from 'src/features/supplier-application/ui/SupplierApplicationForm';
import { Logo } from 'src/shared/components';
import { usePageTitle } from 'src/shared/hooks';

import { Typography } from 'src/shared/components/ui';

const SupplierApplicationPage: React.FC = () => {
  usePageTitle('Supplier Application | Cavela');

  return (
    <div className="bg-white min-h-dvh">
      <div className="grid-cols-2 md:grid flex flex-col h-full w-full">
        {/* ── Left: Form ── */}
        <div className="relative w-full p-8 md:p-12 overflow-y-auto">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ ease: 'easeInOut', duration: 0.6 }}
            className="w-full max-w-2xl mx-auto"
          >
            <div className="h-8 mb-8">
              <Logo />
            </div>

            <div className="flex flex-col gap-2">
              <Typography variant="h1" weight="bold">
                Supplier Application
              </Typography>
              <Typography variant="h3" className="text-primary-text">
                Build Long-Term Manufacturing Partnerships
              </Typography>
              <Typography variant="body-1" className="text-secondary-text mt-1">
                Please note: submitting this form does not guarantee onboarding
                or orders. Our team reviews all applications and will reach out
                if there is a potential fit.
              </Typography>
            </div>

            <SupplierApplicationForm />
          </motion.div>
        </div>

        {/* ── Right: Hero image ── */}
        <div
          className="hidden md:flex items-center justify-center sticky top-0 h-dvh"
          style={{
            background: 'url(/backgrounds/supplierBg.jpg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          }}
        >
          <motion.img
            initial={{ y: 24, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ ease: 'easeInOut', duration: 1 }}
            draggable="false"
            className="w-[60%]"
            alt="supplier info"
            src="/backgrounds/supplierInfo.png"
          />
        </div>
      </div>
    </div>
  );
};

export default SupplierApplicationPage;
